import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { GraduationCap, Sparkles, Library, BookOpen, ShieldPlus } from "lucide-react";

const Tile = ({ to, icon: Icon, title, desc, testid, accent }) => (
  <Link to={to} data-testid={testid} className="kt-card p-6 hover:-translate-y-1 hover:shadow-lg transition block">
    <div className={`w-11 h-11 rounded-xl flex items-center justify-center ${accent || "bg-[#0F2922] text-[#FAFA96]"} mb-3`}><Icon size={22} /></div>
    <h3 className="font-semibold text-[#0F172A]">{title}</h3>
    <p className="text-sm text-slate-600 mt-1">{desc}</p>
  </Link>
);

export default function Dashboard() {
  const { user } = useAuth();
  return (
    <div data-testid="dashboard-page">
      <p className="text-xs uppercase tracking-widest text-[#D97706] font-semibold">Dashboard</p>
      <h1 className="serif text-3xl sm:text-4xl font-bold text-[#0F2922] mt-1">Halo, {user?.name}</h1>
      <p className="text-slate-600 mt-2">Jenjang <b>{user?.jenjang}</b>{user?.university ? ` · ${user.university}` : ""} — pilih fitur untuk memulai.</p>

      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-5 mt-8">
        <Tile to="/beasiswa" icon={GraduationCap} title="Portal Beasiswa" desc="Cari beasiswa S1/S2/S3 dalam & luar negeri." testid="tile-beasiswa" />
        <Tile to="/paper" icon={Sparkles} title="AI Paper + Slide" desc="Generate paper akademik & slide 10 halaman." testid="tile-paper" />
        <Tile to="/direktori-jurnal" icon={Library} title="Direktori Jurnal" desc="Scopus Q1-Q4 & SINTA 2/3/4 + submit langsung." testid="tile-jurnal" />
        <Tile to="/tugas-akhir" icon={BookOpen} title="Ide Tugas Akhir" desc="5 judul + roadmap + daftar pustaka APA." testid="tile-ta" />
        <Tile to="/haki" icon={ShieldPlus} title="Pendaftaran HAKI" desc="Lacak Hak Cipta, Paten, Merek — draft s/d sertifikat." testid="tile-haki" accent="bg-gradient-to-br from-[#D97706] to-amber-500 text-white" />
      </div>

      <div className="mt-10 kt-card p-6">
        <h2 className="serif text-xl font-bold text-[#0F2922]">Tips memulai</h2>
        <ul className="mt-3 text-sm text-slate-600 space-y-2 list-disc pl-5">
          <li>Gunakan <b>AI Paper</b> saat butuh draft cepat lalu revisi manual sesuai gaya kampusmu.</li>
          <li>Filter <b>Direktori Jurnal</b> berdasarkan bidang & indeksasi (Scopus/SINTA) sebelum submit.</li>
          <li>Diskusikan tiap beasiswa/jurnal di kolom komentar untuk mendapatkan insight peer.</li>
        </ul>
      </div>
    </div>
  );
}
